export default __webpack_public_path__ + "static/media/5022.561a0453.png";